export function setWindowTitle(title) {
  // For Electron environment
  if (window.electronAPI && typeof window.electronAPI.setWindowTitle === 'function') {
    window.electronAPI.setWindowTitle(title);
  } 
  // For browser environment
  else {
    document.title = title;
  }
}

export default {
  setWindowTitle
};